import {MvsCrudService} from "../../../../../core/shared/service/crud/mvs-crud.service";
import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';

import {TeTemplateService} from "../../../service/api/te-template.service";
import {TeTemplateGenerateResponseDto} from "../../../model/dto/entity/te-template-generate-response.dto";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {TeTemplateVariableService} from "../../../service/api/te-template-variable.service";
import {TeVariableProviderService} from "../../../service/api/interfaces/te-variable-provider.service";
import {TeContentProviderVariableDto} from "../../../model/dto/api/te.content-provider-variable.dto";
import {TeRenderContextScenarioDto} from "../../../model/dto/api/te-render-context-scenario.dto";
import {TeRenderContextScenarioResultDto} from "../../../model/dto/api/te-render-context-scenario-result.dto";
import {TeTestCaseDto} from "../../../model/dto/entity/te-test-case.dto";
import {TeTestCaseVariableDto} from "../../../model/dto/entity/te-test-case-variable.dto";
import {TeVariableTypeEnum} from "../../../enum/te-variable-type.enum";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";
import {DtoList} from "../../../../../core/shared/dto/dto.list";
import {MvsCoreService} from "../../../../../core/shared/service/mvs-core.service";
import {ObjectRequestList} from "../../../../../core/shared/dto/object/request/object-request-list";
import {DtoImportObjectContext} from "../../../../../core/shared/dto/dto.import.object.context";
import {ObjectIdentifierWithId} from "../../../../../core/shared/basic/object-identifier.with.id";
import {FilterCriteria} from "../../../../../core/shared/filter/api/filter.criteria";
import {Observable} from "rxjs";
import {TeTestCaseContextDataSourceHint} from "../../../interface/te-test-case-context-data-source-hint.interface";

export type TeTestCaseComponentVariableWithMapping = TeContentProviderVariableDto & { useCaseVariable: TeTestCaseVariableDto | null};

export interface TestCaseChangeEvent {
  dto: DtoDetail,
  variables:  TeTestCaseComponentVariableWithMapping[]
}

@Component({
    selector: 'mvs-te-test-case',
    templateUrl: './te-test-case.component.html',
    styleUrls: ['./te-test-case.component.scss'],
    standalone: false
})
export class TeTestCaseComponent implements OnInit, OnChanges, OnDestroy {



    testCaseService: MvsCrudService;
    testCaseVariablesService: MvsCrudService;
  busy: boolean;  // indicator whether the component is busy
  initialized: boolean; // indicator whether the component was initialized

  selectedTestCase: TeTestCaseDto;
  testCaseDtoList: DtoList;

  templateGenerateResponse: TeTemplateGenerateResponseDto;
  trustedGenerateResponseHtml: SafeHtml;
  trustedGenerateResponsePdf: SafeHtml;

  occurredException: string;
  occurredExceptionDetails: string;

  generatePdf: boolean = false;
  outputFormatOptions = [
    { label: 'HTML', value: false },
    { label: 'PDF', value: true }
  ];

  testCaseVariables: TeTestCaseVariableDto[];
  variables: TeTestCaseComponentVariableWithMapping[];

  /** Filtered variables excluding system types (handles string, number, and string-number values from backend) */
  get displayableVariables(): TeTestCaseComponentVariableWithMapping[] {
    if (!this.variables) return [];
    return this.variables.filter(v => {
      const varType = v.variableType as any;
      // Check for 'system' string, numeric 2, and string "2"
      return varType !== 'system' && varType !== 2 && varType !== '2';
    });
  }

  isResultFullView: boolean = false;

  /** Option key for "keep the value the selected test case stores for this alias" — never sent to the backend. */
  static readonly CONTEXT_SCENARIO_TEST_CASE_KEY = '#testCase';
  static readonly CONTEXT_SCENARIO_TEST_CASE_LABEL = 'Wert aus dem Testfall';
  static readonly CONTEXT_DATA_SOURCE_REAL_LABEL = 'Echte Daten';
  static readonly CONTEXT_DATA_SOURCE_SAMPLE_LABEL = 'Beispieldaten';
  /** The global p-tag override hides the severity color, so sample data is colored by a PrimeFlex utility. */
  static readonly CONTEXT_DATA_SOURCE_SAMPLE_STYLE_CLASS = 'bg-orange-600';

  /** Variables offering render-context scenarios (e.g. sysRecipient); one scenario select is shown per entry. */
  contextScenarioVariables: TeTestCaseComponentVariableWithMapping[] = [];
  /** Scenario options per alias. */
  contextScenarioOptions: {[alias: string]: TeRenderContextScenarioDto[]} = {};
  /** Selected scenario key per alias. */
  selectedContextScenarios: {[alias: string]: string} = {};
  /** Per render context of the last result: real or sample data. Shown next to the result, never inside it. */
  contextDataSourceHints: TeTestCaseContextDataSourceHint[] = [];

  @Input() templateId: number;
  @Input() contentProviderId: number;
  @Input() variableProviderServiceInput: TeVariableProviderService;
  @Input() generateFn: (id: number, testCaseId: number, generatePdf: boolean,
                        objectVars: {[key: string]: ObjectIdentifierWithId}, simpleVars: {[key: string]: any},
                        contextScenarios?: {[alias: string]: string}) => Observable<TeTemplateGenerateResponseDto>;
  @Input() initialTestCaseId: number;
  @Output() onSelectTestCase = new EventEmitter<TestCaseChangeEvent>;

  constructor(
      protected coreService: MvsCoreService,
      protected templateService: TeTemplateService,
      protected templateVariableService: TeTemplateVariableService,
      public sanitizer: DomSanitizer) {
        this.testCaseService = this.coreService.getCrudService("te.TeTestCase");
        this.testCaseVariablesService = this.coreService.getCrudService("te.TeTestCaseVariable");
  }

  ngOnInit(): void {
    this.initComponent();
    this.refreshComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.refreshTestCases();

    if (this.getContentProviderId()) {
      this.initialized = true;
    }

  }

  /**
   * Get the effective content provider ID (supports both templateId and contentProviderId).
   */
  protected getContentProviderId(): number {
    return this.contentProviderId || this.templateId;
  }

  /**
   * Get the effective variable provider service.
   */
  protected getVariableProviderService(): TeVariableProviderService {
    return this.variableProviderServiceInput || this.templateVariableService;
  }

  /**
   * Process changes within Binding.
   * @param changes
   */
  ngOnChanges(changes: SimpleChanges): void {

    if (!this.initialized) {
      return;
    }

    if (changes["templateId"] || changes["contentProviderId"]) {
      this.refreshComponent();
    }
  }

  /**
   * Refresh Test Cases.
   */
  refreshTestCases() {
    this.busy = true;

    // retrieve test cases
    this.testCaseService.list(ObjectRequestList.createSimple(DtoImportObjectContext.createEmpty())).subscribe(value => {
      this.testCaseDtoList = value;
      this.busy = false;

      // Auto-select previously selected test case if initialTestCaseId is provided
      if (this.initialTestCaseId && !this.selectedTestCase && this.testCaseDtoList?.entries) {
        const match = this.testCaseDtoList.entries.find((tc: any) => tc.id === this.initialTestCaseId);
        if (match) {
          this.selectedTestCase = match;
          this.refreshTestCaseVariables();
        }
      }
    });

    // store variables
    this.getVariableProviderService().listVariables(this.getContentProviderId()).subscribe(value => {
      this.variables = value.map(entry => ({ ...entry, useCaseVariable: null}));
      this.refreshContextScenarios(true);
    });


  }

  /**
   * Generate Test.
   */
  onGenerate() {
    this.generateDocument(this.generatePdf);
  }

  onRefreshResult() {
    this.generateDocument(this.generatePdf);
  }

  generateDocument(generatePdf: boolean) {
    this.templateGenerateResponse = null;
    this.trustedGenerateResponseHtml = null;
    this.trustedGenerateResponsePdf = null;
    this.contextDataSourceHints = [];
    this.occurredException = null;
    this.occurredExceptionDetails = null;

    const objectVariables: {[key: string]: ObjectIdentifierWithId} = {};
    const simpleVariables: {[key: string]: any} = {};

    // fill variables
    if (this.variables) {
      for (let variable of this.variables) {
        if (variable.useCaseVariable) {
          // Cast to `any` to allow comparing against both string and numeric enum values.
          // The API may return variableType as a numeric ordinal (0, 1, 2) or a string.
          const varType: any = variable.variableType;
          if (varType === 'object' || varType === TeVariableTypeEnum.object) {
            objectVariables[variable.alias] = new ObjectIdentifierWithId(variable.useCaseVariable.objectTypeDtoId, null, variable.useCaseVariable.objectId);
          } else if (varType === 'simple' || varType === TeVariableTypeEnum.simple) {
            simpleVariables[variable.alias] = variable.useCaseVariable.simpleValue;
          }
        }
      }
    }

    const contextScenarios = this.getContextScenarios();

    this.busy = true;

    const generateObs = this.generateFn
        ? this.generateFn(this.getContentProviderId(), this.selectedTestCase.id, generatePdf,
            objectVariables, simpleVariables, contextScenarios)
        : this.templateService.generateViaTestCase(this.getContentProviderId(), this.selectedTestCase.id, generatePdf,
            objectVariables, simpleVariables, contextScenarios);

    generateObs.subscribe({
          next: (value) => {
            if (value.errors || value.errorOccurred) {
              this.occurredException = value.exception;
              this.occurredExceptionDetails = value.exceptionDetails;
            } else {
              this.templateGenerateResponse = value;
              this.contextDataSourceHints = this.buildContextDataSourceHints(value.contextScenarioResults);
              if (generatePdf) {
                this.trustedGenerateResponsePdf = this.sanitizer.bypassSecurityTrustResourceUrl(value.document);
              } else {
                this.trustedGenerateResponseHtml = this.sanitizer.bypassSecurityTrustHtml(value.document);
              }
            }
            this.busy = false;
          },
          error: (error) => {
            this.occurredException = 'Fehler bei der Template-Generierung';
            this.occurredExceptionDetails = error?.error?.message || error?.message || 'Unbekannter Fehler';
            this.busy = false;
          }
    });
  }

  onHideResult() {
    this.templateGenerateResponse = null;
    this.trustedGenerateResponseHtml = null;
    this.trustedGenerateResponsePdf = null;
    this.contextDataSourceHints = [];
  }

  /**
   * Derive one scenario select per variable offering render-context scenarios and preselect it: the scenario the
   * selected test case stores for the alias (simple value = scenario key), the test case's own value when it
   * stores anything else (e.g. a JSON stub — the backend then takes it unchanged), otherwise the provider's
   * default scenario. The selection is sent with every generation, so it must never hide the test case's value.
   * @param keepSelection true when only the variables were reloaded: the user's choice stays for every alias that
   *                      still offers it. False when the test case changed: back to the preselection.
   */
  refreshContextScenarios(keepSelection: boolean) {

    this.contextScenarioVariables = (this.variables || []).filter(variable => variable.contextScenarios?.length);

    const options: {[alias: string]: TeRenderContextScenarioDto[]} = {};
    const selected: {[alias: string]: string} = {};

    for (const variable of this.contextScenarioVariables) {

      const scenarios = variable.contextScenarios;
      const testCaseVariable = this.testCaseVariables?.find(entry => entry.alias === variable.alias);
      let preselected: string;

      if (!testCaseVariable) {
        options[variable.alias] = scenarios;
        preselected = scenarios.find(scenario => scenario.defaultScenario)?.key;
      } else if (scenarios.some(scenario => scenario.key === testCaseVariable.simpleValue)) {
        options[variable.alias] = scenarios;
        preselected = testCaseVariable.simpleValue;
      } else {
        const testCaseOption: TeRenderContextScenarioDto = {
          key: TeTestCaseComponent.CONTEXT_SCENARIO_TEST_CASE_KEY,
          label: TeTestCaseComponent.CONTEXT_SCENARIO_TEST_CASE_LABEL,
          defaultScenario: false
        };
        options[variable.alias] = [testCaseOption, ...scenarios];
        preselected = testCaseOption.key;
      }

      const current = this.selectedContextScenarios[variable.alias];
      const stillOffered = !!current && options[variable.alias].some(option => option.key === current);
      selected[variable.alias] = keepSelection && stillOffered ? current : preselected;
    }

    this.contextScenarioOptions = options;
    this.selectedContextScenarios = selected;
  }

  /**
   * Label of a scenario select, named after the provider's label of the variable.
   */
  getContextScenarioLabel(variable: TeTestCaseComponentVariableWithMapping): string {
    return `${variable.name || variable.alias}: Szenario`;
  }

  /**
   * Scenario per alias (alias → scenario key) for the generate request; undefined when nothing was chosen, so the
   * request of a template without render-context variables stays as it was.
   */
  getContextScenarios(): {[alias: string]: string} | undefined {

    const contextScenarios: {[alias: string]: string} = {};

    for (const variable of this.contextScenarioVariables) {
      const scenarioKey = this.selectedContextScenarios[variable.alias];
      if (scenarioKey && scenarioKey !== TeTestCaseComponent.CONTEXT_SCENARIO_TEST_CASE_KEY) {
        contextScenarios[variable.alias] = scenarioKey;
      }
    }

    return Object.keys(contextScenarios).length ? contextScenarios : undefined;
  }

  onContextScenarioChange() {
    if (this.selectedTestCase) {
      this.generateDocument(this.generatePdf);
    }
  }

  /**
   * One tag per render context the backend reports with real or sample data; 'none' gets no tag, and results for
   * an alias without a scenario select are ignored. The tooltip is the backend's hint, unchanged.
   */
  buildContextDataSourceHints(results: TeRenderContextScenarioResultDto[]): TeTestCaseContextDataSourceHint[] {

    const scenarioAliases = this.contextScenarioVariables.map(variable => variable.alias);
    const shown = (results || []).filter(result => scenarioAliases.includes(result.alias)
        && (result.dataSource === 'real' || result.dataSource === 'sample'));

    return shown.map(result => {

      const sample = result.dataSource === 'sample';
      const text = sample
          ? TeTestCaseComponent.CONTEXT_DATA_SOURCE_SAMPLE_LABEL
          : TeTestCaseComponent.CONTEXT_DATA_SOURCE_REAL_LABEL;
      const variable = this.contextScenarioVariables.find(entry => entry.alias === result.alias);

      return {
        alias: result.alias,
        label: shown.length > 1 ? `${variable.name || result.alias}: ${text}` : text,
        severity: sample ? 'warn' : 'info',
        styleClass: sample ? TeTestCaseComponent.CONTEXT_DATA_SOURCE_SAMPLE_STYLE_CLASS : '',
        tooltip: result.hint
      };
    });
  }

  refreshTestCaseVariables() {
    this.busy = true;

    const dtoListRequest = new ObjectRequestList(
        false,
        [FilterCriteria.create('testCase', FilterCriteria.cOperatorEqual, this.selectedTestCase.id, null)],
        []
    );

    this.handleSelectTestCase();

    this.testCaseVariablesService.list(dtoListRequest).subscribe(res => {
      this.testCaseVariables = res.entries;
      this.refreshVariableMapping();
      this.refreshContextScenarios(false);
      this.busy = false;
    });

  }

  handleSelectTestCase() {
    const event: TestCaseChangeEvent = {
      dto: this.selectedTestCase,
      variables: this.variables
    }
    this.onSelectTestCase.emit(event);
  }

  /**
   * Combine information from the test case with the required import data of the template.
   */
  refreshVariableMapping() {

    if (!this.variables) {
      return;
    }

    for (let variable of this.variables) {

      // set tu null
      variable.useCaseVariable = null;

      if (!this.testCaseVariables) {
        continue;
      }


      for (let testCaseVariable of this.testCaseVariables) {

        // check whether alias is set
        if (testCaseVariable.alias && testCaseVariable.alias !== variable.alias) {
          continue;
        }

        // Cast to `any` to allow comparing against both string and numeric enum values.
        // The API may return variableType as a numeric ordinal (0, 1, 2) or a string.
        const varType: any = variable.variableType;

        // check whether types are matching
        if ((varType === 'object' || varType === TeVariableTypeEnum.object) && (testCaseVariable.type != TeVariableTypeEnum.object || variable.objectTypeDtoId != testCaseVariable.objectTypeDtoId)){
          continue;
        } else if ((varType === 'simple' || varType === TeVariableTypeEnum.simple) && testCaseVariable.type != TeVariableTypeEnum.simple){
          continue;
        }


        let isMatch: boolean = false;

        // check for perfect match (including alias)
        if (varType === 'object' || varType === TeVariableTypeEnum.object) {
          if (variable.objectTypeDtoId && variable.objectTypeDtoId == testCaseVariable.objectTypeDtoId) {
            isMatch = true;
          }
        } else if (varType === 'simple' || varType === TeVariableTypeEnum.simple) {
          isMatch = true;
        }

        if (isMatch) {
          variable.useCaseVariable = testCaseVariable;
        }

        if (testCaseVariable.alias) {
          // perfect match, we can stop any further processing
          break;
        }

      }

    }

  }

  onRefreshTestCases() {
    this.refreshTestCases();
  }

  /**
   * Destroy component.
   */
  ngOnDestroy(): void {

  }
}
